module.exports = __webpack_public_path__ + "static/media/IMG_2724.c0f6cfa6.JPG";